/**
 * localStorage implementation for saving content (like auto-draft saving)
 * should work in almost all browsers (IE9 even), but if not it should fail gracefully
 */
// NOTE: make sure note to shorthand window.localStorage here, because if it is disabled, the code will error out right away.

class Storage {
    constructor() {
        this.supported = false;
        this._isSupported();
    }
    /**
      * Returns blank or the value for the key
      * @param {String} key Storage key.
      * @return {String}
      */
    get(key) {
        let txt = null;
        if (this.supported) {
            txt = window.localStorage.getItem(key);
        }
        return (txt !== null) ? txt : '';
    }
    /**
      * Store a value for the key
      * Warning: browsers vary for the amount of data you can store (usually ~5mb)
      * @param {String} key Storage key
      * @param {String} txt Value to save
      * @return {Boolean} returns false on error but not if storage is unsupported
      */
    set(key, txt) {
        if (this.supported) {
            try {
                window.localStorage.setItem(key, txt);
            } catch (e) {
                //Should only happen when over quota
                return false;
            }
            return true;
        } else {
            return true;
        }
    }
    /**
      * Remove a key
      * @param {String} key Storage key.
      */
    remove(key) {
        if (this.supported) {
            window.localStorage.removeItem(key);
        }
    }
    /**
      * Iterate through all the stored keys and apply a callback
      * NOTE: be careful using this as other elements may be using the storage (for instance the CKE scayt stores some stuff)
      * we make a new key array so we can iterate and remove storage keys without messing up the iteration
      * @param {Function} callback function that will be passed each key (iterated through) as the only argument with 'this' set to the storage object
      */
    iterate(callback) {
        if (this.supported && window.localStorage.length > 0) {
            const keys = [];
            for (let i = 0; i < window.localStorage.length; i++) {
                keys.push(window.localStorage.key(i));
            }
            if (keys.length > 0) {
                for (let x = 0; x < keys.length; x++) {
                    callback.call(this, keys[x]);
                }
            }
        }
    }
    /**
      * Make sure localStorage is supported in browser
      */
    _isSupported() {
        try {
            if ('localStorage' in window && window.localStorage !== null) {
                this.supported = true;
            } else {
                return;
            }
        } catch (e) {
            return;
        }
    }
}

export default new Storage();
